import {combineReducers, Reducer} from 'redux'
import {ClientsState} from '@models/client'
import {ClientsActionTypes} from '@actions/client';


// Type-safe initialState!
export const initialState: ClientsState = {
  data: [],
  isFetched: false
};


const data = (state = initialState.data, action) => {
  switch (action.type) {
    case ClientsActionTypes.FETCH_SUCCESS: {
      return action.payload
    }
    
    default:
      return state
  }
};


const isFetched = (state = initialState.isFetched, action) => {
  switch (action.type) {
    case ClientsActionTypes.FETCH_SUCCESS: {
      return true
    }
    
    default:
      return state
  }
};

const reducer: Reducer<ClientsState> = combineReducers({
  data,
  isFetched
});

export {reducer as clientReducer}
